export default "__VITE_ASSET__Y1a4naN9__"